import Swiper from "swiper"

const swiperArray = document.querySelectorAll(".collection-subnav__swiper")
swiperArray.forEach((swiperEl) => {
    const swiper = new Swiper(swiperEl, {
        spaceBetween: 10,
        slidesPerView: "auto",
        breakpoints: {
            480: {
                spaceBetween: 21,
            },
        },
        centerInsufficientSlides: true,
        threshold: 12,
    })
})

const subSwiperArray = document.querySelectorAll(".collection-subnav__sub__swiper")
subSwiperArray.forEach((swiperEl) => {
    const subswiper = new Swiper(swiperEl, {
        spaceBetween: 21,
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        threshold: 12,
    })
})

const subcollectionNavButtons = document.querySelectorAll(".collection-subnav__menu")
subcollectionNavButtons.forEach((button) => {
    button.addEventListener("click", () => {
        const filter = button.dataset.filter
        subSwiperArray.forEach((subSwiper) => {
            const filterParent = subSwiper.parentElement.dataset.filterparent
            if (filterParent === filter) {
                subSwiper.parentElement.classList.add("visible")
            } else {
                subSwiper.parentElement.classList.remove("visible")
            }
        })
    })
})

subSwiperArray.forEach((subSwiper) => {
    const subSwiperAnchors = Array.from(subSwiper.querySelectorAll("a"))
    const subSwiperLinks = subSwiperAnchors.map((anchor) => anchor.getAttribute("href"))
    const currentPath = window.location.pathname
    if (subSwiperLinks.includes(currentPath)) {
        subSwiper.parentElement.classList.add("visible")
    }
})
